import React from "react";
import { Select } from "semantic-ui-react";

export default function SimpleSelectComponent({
  label = "",
  options,
  value,
  onChange = () => {},
  className = "flex-row-center",
  labelClassName = "pr-1",
  selectClassName = "w-100",
}) {
  return (
    <div className={className}>
      {label && (
        <label className={labelClassName}>
          <b>{label}</b>
        </label>
      )}
      <Select
        className={selectClassName}
        options={options}
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
